module.exports = __webpack_public_path__ + "img/logo-before-laranja.36b95afe.png";